module.exports = __webpack_public_path__ + "static/media/file16.16b8d756.jpg";